import { render } from "./knowledgebasedetails.vue?vue&type=template&id=eb7f17aa&scoped=true"
import script from "./knowledgebasedetails.vue?vue&type=script&lang=js"
export * from "./knowledgebasedetails.vue?vue&type=script&lang=js"

import "./knowledgebasedetails.vue?vue&type=style&index=0&id=eb7f17aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-eb7f17aa"

export default script